const PushNotification = {
  ShipperApp: 1,
  TransporterApp: 2,
  ConsigneeApp: 3,
  DriverApp: 4,
  LmsApp: 5,
};

const PushNotificationAppTypes = Object.values(PushNotification);

module.exports = {
  PushNotification, PushNotificationAppTypes,
};
